import React, { memo, useCallback } from "react";
import { InlineMath } from "react-katex"; // Import InlineMath for inline equations

const AnswerInput = ({ inputValue, handleInputChange }) => {
  // Function to format input as KaTeX expression if it's a fraction
  const formatFraction = useCallback((value) => {
    // Ensure the value is a string
    const sanitizedValue = value || ""; // Default to an empty string if value is undefined
    const parts = sanitizedValue.split("/");

    // Check if there are exactly two parts and both are numbers
    if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
      return `\\frac{${parts[0]}}{${parts[1]}}`; // KaTeX fraction format
    }

    return sanitizedValue; // Return the original input if it's not a valid fraction
  }, []);

  return (
    <div>
      {/* Input Field */}
      <input
        value={inputValue || ""} // Ensure inputValue is never undefined
        onChange={handleInputChange}
        style={{
          width: "300px",
          padding: "10px 15px",
          borderRadius: "10px",
          border: "1px solid #ccc",
          outline: "none",
        }}
      />
      {/* Preview Section */}
      <div style={{ marginTop: "25px", fontSize: "16px", fontFamily: "Arial" }}>
        <strong>Answer Preview:</strong>
        <div style={{ marginTop: "5px" }}>
          <InlineMath math={formatFraction(inputValue)} />
        </div>
      </div>
    </div>
  );
};

export default memo(AnswerInput);
